// extracted by mini-css-extract-plugin
export default {"root":"OrgListItem_root__CCC1t","pending":"OrgListItem_pending__ZqiA-","placeHolderShimmer":"OrgListItem_placeHolderShimmer__k3rH6"};